import lodash from 'lodash'
import React from 'react'
import styled from 'styled-components'

import TooltipTrigger from '../../../../1stlog-ui/src/components/TooltipTrigger'

const Wrapper = styled.div`
  display: ${({ display }) => display};
`

const Img = styled.img`
  width: ${({ size }) => size || '40'}px;
  height: ${({ size }) => size || '40'}px;
`

const HazmatLabel = (props) => {
  const { label, size, display = 'inline-block' } = props

  return (
    <Wrapper _className={label === 'env' ? 'ml-1' : ''} display={display}>
      <TooltipTrigger tooltip={getText(label)}>
        <Img
          size={size}
          src={`https://cdn.1st-scan.net/hazmat-labels/${getNewImage(label)}`}
        />
      </TooltipTrigger>
    </Wrapper>
  )
}

export default HazmatLabel

function getNewImage(label) {
  if (label === 'env') {
    return 'Envir_3000.png'
  }
  let filename = label
  if (filename === '2') {
    filename = '2.1'
  }
  return `with-text/${filename}.png`
}

function getImage(label) {
  /*
    "class1-1_3000.png"
    "class1-2_3000.png"
    "class1-3_3000.png"
    "class1-4_3000.png"
    "class1-5_3000.png"
    "class1-6_3000.png"
    "class2_gruen_schwarz_3000.png"
    "class2_rot_schwarz_3000.png"
    "class2_rot_weiss_3000.png"
    "class2_tox_3000.png"
    "class3_rot_schwarz_3000.png"
    "class3_rot_weiss_3000.png"
    "class4_blau_schwarz_3000.png"
    "class4_rot-weiss_3000.png"
    "class5-1_gelb_3000.png"
    "class5-2_gelb-rot_schwarz_3000.png"
    "class6_3000.png"
    "class8_3000.png"
    "class9_3000.png"
  */
  switch (label) {
    case '1':
      return 'with-text/1.png'
    case '1.1':
      return 'class1-1_3000.png'
    case '1.2':
      return 'class1-2_3000.png'
    case '1.3':
      return 'class1-3_3000.png'
    case '1.4':
      return 'class1-4_3000.png'
    case '1.5':
      return 'class1-5_3000.png'
    case '1.6':
      return 'class1-6_3000.png'
    case '2':
      return 'with-text/2.1.png'
    case '2.1':
      return 'with-text/2.1.png'
    case '2.2':
      return 'with-text/2.2.png'
    case '2.3':
      return 'with-text/2.3.png'
    case '3':
      return 'with-text/3.png'
    case '4':
      return 'with-text/4.2.png'
    case '4.1':
      return 'with-text/4.1.png'
    case '4.2':
      return 'with-text/4.2.png'
    case '4.3':
      return 'with-text/4.3.png'
    case '5':
      return 'with-text/5.2.png'
    case '5.1':
      return 'with-text/5.1.png'
    case '5.2':
      return 'with-text/5.2.png'
    case '6':
    case '6.1':
      return 'with-text/6.1.png'
    case '6.2':
      return 'with-text/6.2.png'
    case '7':
      return 'with-text/7X.png'
    case '8':
      return 'with-text/8.png'
    case '9':
      return 'with-text/9.png'
    case 'env':
      return 'Envir_3000.png'
    default:
      return 'missing.png'
  }
}

function getText(label) {
  switch (label) {
    case '1':
      return 'Kennzeichnung 1 - Explosive Stoffe'
    case '1.1':
      return 'Kennzeichnung 1.1 - Stoffe und Gegenstände, die massenexplosionsfähig sind'
    case '1.2':
      return 'Kennzeichnung 1.2 - Stoffe und Gegenstände, die die Gefahr der Bildung von Splittern, Spreng- und Wurfstücken aufweisen, aber nicht massenexplosionsfähig sind'
    case '1.3':
      return 'Kennzeichnung 1.3 - Stoffe und Gegenstände, die eine Feuergefahr besitzen und die entweder eine geringe Gefahr durch Luftdruck oder eine geringe Gefahr durch Splitter-, Spreng- und Wurfstücke oder durch beides aufweisen, aber nicht massenexplosionsfähig sind, bei deren Verbrennung beträchtliche Strahlungswärme entsteht, oder die nacheinander so abbrennen, dass eine geringe Luftdruckwirkung oder Splitter-, Sprengstück-, Wurfstückwirkung oder beide Wirkungen entstehen'
    case '1.4':
      return 'Kennzeichnung 1.4 - Stoffe und Gegenstände, mit geringer Explosionsgefahr – Auswirkungen bleiben auf das Versandstück beschränkt'
    case '1.5':
      return 'Kennzeichnung 1.5 - Sehr unempfindliche massenexplosionsfähige Stoffe – Als Minimalanforderung gilt, dass sie beim Außenbrandversuch nicht explodieren dürfen'
    case '1.6':
      return 'Kennzeichnung 1.6 - Extrem unempfindliche nicht massenexplosionsfähige Stoffe – Stoffe bei denen (unter normalen Beförderungsbedingungen) eine vernachlässigbare Wahrscheinlichkeit zu einer unbeabsichtigten Zündung oder Fortpflanzung der Explosion besteht'
    case '2':
      return 'Kennzeichnung 2 - Gase und gasförmige Stoffe'
    case '2.1':
      return 'Kennzeichnung 2.1 - Gase und gasförmige Stoffe'
    case '2.2':
      return 'Kennzeichnung 2.2 - Gase und gasförmige Stoffe'
    case '3':
      return 'Kennzeichnung 3 - Entzündbare flüssige Stoffe'
    case '4':
      return 'Kennzeichnung 4 - Entzündbare feste Stoffe'
    case '4.1':
      return 'Kennzeichnung 4.1 - Entzündbare feste Stoffe, selbstzersetzliche Stoffe und desensibilisierte explosive Stoffe'
    case '4.2':
      return 'Kennzeichnung 4.2 - Selbstentzündliche Stoffe'
    case '4.3':
      return 'Kennzeichnung 4.3 - Stoffe, die in Berührung mit Wasser entzündliche Gase bilden'
    case '5':
      return 'Kennzeichnung 5 - Entzündend (oxidierend) wirkende Stoffe'
    case '5.1':
      return 'Kennzeichnung 5.1 - Entzündend wirkende Stoffe'
    case '5.2':
      return 'Kennzeichnung 5.2 - Organische Peroxide'
    case '6':
      return 'Kennzeichnung 6 - Giftige Stoffe'
    case '6.1':
      return 'Kennzeichnung 6.1 - Giftige Stoffe'
    case '6.2':
      return 'Kennzeichnung 6.2 - Ansteckungsgefährliche Stoffe'
    case '7':
    case '7X':
      return 'Kennzeichnung 7 - Radioaktive Stoffe'
    case '8':
      return 'Kennzeichnung 8 - Ätzende Stoffe'
    case '9':
      return 'Kennzeichnung 9 - Verschiedene gefährliche Stoffe und Gegenstände'
    case 'env':
      return 'Umweltgefährdend'
    default:
      return `${label}`
  }
}
